import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "PhysicalExam",
  [
    [
      "path",
      {
        d: "M20.87,5.97c-1.7,0-3.08,1.38-3.08,3.08,0,1.37.91,2.58,2.22,2.96v4.43c0,3.19-2.59,5.78-5.78,5.78s-5.74-2.55-5.78-5.71c3.8-.43,6.65-3.62,6.65-7.46V3.06c0-.97-.61-1.85-1.52-2.19l-1.99-.75c-.22-.08-.45-.07-.66.02-.21.1-.37.27-.45.48s-.07.45.02.66.27.37.48.45l1.99.75c.24.09.4.32.4.58v5.99c0,3.19-2.59,5.78-5.78,5.78S1.79,12.24,1.79,9.05V3.06c0-.26.16-.49.4-.58l1.99-.75c.22-.08.39-.24.48-.45s.1-.44.02-.66c-.17-.45-.67-.67-1.11-.51l-2,.75C.67,1.21.06,2.09.06,3.06v5.99c0,3.84,2.85,7.03,6.65,7.46.04,4.11,3.39,7.43,7.51,7.43s7.51-3.37,7.51-7.51v-4.43c1.31-.38,2.22-1.58,2.22-2.96,0-1.7-1.38-3.08-3.08-3.08ZM22.22,9.05c0,.75-.61,1.35-1.35,1.35s-1.35-.61-1.35-1.35.61-1.35,1.35-1.35,1.35.61,1.35,1.35Z",
      },
    ],
  ],
  "currentColor"
);
